'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
export default function ZendeskWidget() {
  const pathname = usePathname();
  const isMarketplace = pathname === '/overview' || pathname === '/welcome';
  const isEditTool = pathname.includes('/edits');
  useEffect(() => {
    // Avoid injecting multiple times
    if (document.getElementById('ze-snippet')) return;
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=b0521312-604b-4eab-8273-bba86bcb87e5';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // Show/hide widget based on current page
  useEffect(() => {
    const toggleWidget = () => {
      const zE = (window as any).zE;
      if (zE) {
        if (isMarketplace || isEditTool) {
          zE('messenger', 'hide');
        } else {
          zE('messenger', 'show');
        }
      }
    };

    // Try immediately and also after a delay (widget may not be loaded yet)
    toggleWidget();
    const timeout = setTimeout(toggleWidget, 2000);
    return () => clearTimeout(timeout);
  }, [isMarketplace, isEditTool]);
  return null;
}